<template>
  <section>
    <div class="container card">
        <div class="card-body">
            <h3 class="card-title text-primary" v-if="false">{{ $t("lang.onBoarding.summary") }}</h3>
            <p class="text-secondary" v-if="false">{{ $t("lang.onBoarding.summary_description") }}</p>

            <p class="lead pt-2 font-weight-bold" v-if="false">
                <span class="text-primary">{{ onBoarding.step3.appointmentPrice }}€ {{ $t("lang.label.net") }} </span>
                / {{ $t("lang.label.meeting") }}
            </p>
            <div v-if="onBoarding.step>1 && false">
              <p class="mt-4 mb-2 font-weight-bold">
                {{ $t("lang.onBoarding.estimated_size_target") }}
              </p>
              <div class="progress mb-4" style="height: 100%;">
                <div class="progress-bar" :class="onBoarding.summary.progressBarColor" role="progressbar" :style="onBoarding.summary.progressBarPercentage">
                 {{ $t("lang.onBoarding.prospects",{'prospects':new Intl.NumberFormat('es-ES').format(onBoarding.apollo.total_result) }) }} </div>
              </div>
            </div>
            <div class="p-2 mt-3 bg-light text-dark rounded" v-if="onBoarding.step==1">
                <img src="@/assets/images/oliver.png"  alt="" />
                <p class="d-inline p-2 font-weight-bold">
                    OliverTips
                </p>
                <p class="p-2">
                    {{ $t("lang.onBoarding.summary_tip") }}
                </p>
            </div>
            <div class="p-2 mt-3 bg-light text-dark rounded" v-if="onBoarding.step==2">
                <img src="@/assets/images/oliver.png"  alt="" />
                <p class="d-inline p-2 font-weight-bold">
                    OliverTips
                </p>
                <p class="p-2">
                    {{ $t("lang.onBoarding.summary_tip_2") }}
                </p>

                <p class="p-2">
                    {{ $t("lang.onBoarding.summary_tip_2_1") }}
                </p>
            </div>

        <div class="dropdown-divider mt-4" v-if="false"></div>
        <div>
          <div class="row" v-if="false">
            <p class="font-weight-bold mb-3 ml-3">{{ $t("lang.onBoarding.next_step") }}</p>

            

          </div>

          <div id="accordion">
            <div class="card" v-if="false">
              <div class="card-header" id="headingOne">
                <h5 class="mb-0">
                  <span class="text-primary my-2 ml-2 small"  :class="(onBoarding.step!=1||(onBoarding.step==1 && onBoarding.substep==0))?'collapsed':'font-weight-bold'" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    1 - {{ $t("lang.onBoarding.describe_your_services") }}
                  </span>
                </h5>
              </div>

              <div id="collapseOne" class="collapse" :class="(onBoarding.step==1 && onBoarding.substep!=0)?'show':' '" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body">
                  <div class="embed-responsive embed-responsive-16by9 mt-3 mb-3">
                    <VideoToolToy :url="'https://player.vimeo.com/video/748667005?h=89a296cb5c'"  />
                  </div>
                </div>
              </div>
            </div>
            <div class="card" v-if="false">
              <div class="card-header" id="headingTwo">
                <h5 class="mb-0">
                  <span class="text-primary my-2 ml-2 small"  :class="(onBoarding.step!=2)?'collapsed':'font-weight-bold'" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    2 - {{ $t("lang.onBoarding.what_are_your_targets") }}
                  </span>
                </h5>
              </div>
              <div id="collapseTwo" class="collapse" :class="(onBoarding.step==2)?'show':' '" aria-labelledby="headingTwo" data-parent="#accordion">
                <div  class="card-body">
                  <div class="embed-responsive embed-responsive-16by9">
                  <VideoToolToy :url="'https://player.vimeo.com/video/748667097?h=b939bb36c2'"  />
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingThree">
                <h5 class="mb-0">
                  <span class="text-primary my-2 ml-2 small" :class="(onBoarding.step!=3)?'collapsed':'font-weight-bold'" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    3 - {{ $t("lang.onBoarding.finalizing_order") }}
                  </span>
                </h5>
              </div>
              <div id="collapseThree" class="collapse" :class="(onBoarding.step==3)?'show':' '"  aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                  
                  <div class="embed-responsive embed-responsive-16by9">
                    <!-- <iframe v-if="false" class="embed-responsive-item" src="https://www.youtube.com/embed/CrMAy18VRg4"
                      allowfullscreen></iframe> -->
                      <VideoToolToy :url="'https://player.vimeo.com/video/790811900?h=e08d5d82f1'"/>

                    
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    
  </section>
</template>

<script>

import { mapState } from "vuex";
import VideoToolToy from '@/components/Onboarding/VideoToolToy.vue'

export default {
  components:{
    VideoToolToy
  },
  computed: {
    ...mapState({
      onBoarding: state => state.onboarding
    })
  },
  
  methods: {
    showModal(modal) {
      this.$modal.show(modal);
    },
    closeModal(modal) {
      this.$modal.hide(modal);
      this.request = false;
    },
    validate() {
      if (this.onBoarding.step1.serviceDescription_1 == "" || this.onBoarding.step1.serviceDescription_2 == "" || 
          this.onBoarding.step1.serviceDescription_3 == "" || this.onBoarding.step1.serviceDescription_4 == "" || 
          this.onBoarding.step1.serviceDescription_5 == "" || this.onBoarding.step1.serviceDescription_6 == "" || 
          this.onBoarding.step1.serviceDescription_7 == "" || this.onBoarding.step1.serviceDescription_8 == "" || 
          this.onBoarding.step1.serviceDescription_9 == "" || this.onBoarding.step1.serviceDescription_10.value == "" || 
          this.onBoarding.step1.serviceDescription_10.value2 == "" || this.onBoarding.step1.serviceDescription_10.value3 == "" || 
          this.onBoarding.step1.serviceDescription_11.value1 == "" || this.onBoarding.step1.serviceDescription_10.value2 == "" || 
          this.onBoarding.step1.serviceDescription_11.value3 == "" ) {
          
          this.step1hasError = true;
          this.showModal("mails")
      
      } else {
        this.showModal("confirm")
      }
    },
  }

 
  }
</script>